import ElementQuery from "react-element-query";
import { createGlobalStyle } from "styled-components";
import * as React from 'react';
export default {
  ElementQuery,
  createGlobalStyle,
  React
};